import { NgModule } from '@angular/core';

import { HisAmountPipe } from 'hisng';

import { CommonSharedModule } from './common-shared.module';
import { PersonalAgreementService } from './service/personal-agreement.service';
import { RightsUtils } from './service/rights-utils';

/**
 * CoreModule for common components.
 */
@NgModule( {
    imports: [
        CommonSharedModule,
    ],
    declarations: [
    ],
    exports: [
        CommonSharedModule,
    ],
    providers: [
        HisAmountPipe,
        RightsUtils,
        PersonalAgreementService
    ],
} )

export class CommonCoreModule {
}
